import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { ConfirmationModal } from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/ConfirmationModal";
import {
    StyledConfirmationModalButtonsContainer,
    StyledConfirmationModalLabel,
    StyledModalErrorBannerWrapper,
} from "app/pages/sales-intelligence/common-components/modals/ConfirmationModal/styles";
import { ModalErrorBanner } from "app/pages/sales-intelligence/common-components/modals/ModalErrorBanner/ModalErrorBanner";

type Props = {
    errorMessage?: string;
    isOpen: boolean;
    isSubmitLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const ScoringRuleDeleteModal = ({ errorMessage, isOpen, isSubmitLoading, onClose, onConfirm }: Props) => (
    <ConfirmationModal
        isOpened={isOpen}
        titleKey="si.pages.score_settings.delete_modal.title"
        dataAutomation="scoring-rule-delete-modal"
    >
        <I18n
            element={StyledConfirmationModalLabel}
            translatable={{ key: "si.pages.score_settings.delete_modal.details" }}
        />
        {errorMessage ? (
            <StyledModalErrorBannerWrapper>
                <ModalErrorBanner
                    message={errorMessage}
                    dataAutomation="scoring-rule-delete-modal-error"
                />
            </StyledModalErrorBannerWrapper>
        ) : null}
        <StyledConfirmationModalButtonsContainer>
            <Button
                type="flatDark"
                onClick={onClose}
                data-automation="scoring-rule-delete-modal-cancel"
            >
                {translate("si.common.button.cancel")}
            </Button>
            <Button
                type="warning"
                isLoading={isSubmitLoading}
                onClick={onConfirm}
                data-automation="scoring-rule-delete-modal-confirm"
            >
                {translate("si.pages.score_settings.delete_modal.confirm")}
            </Button>
        </StyledConfirmationModalButtonsContainer>
    </ConfirmationModal>
);
